document.addEventListener('DOMContentLoaded', function () {
  const triggers = document.querySelectorAll('.video-trigger');
  const popup = document.getElementById('video-popup');
  const popupVideo = document.getElementById('popup-video');
  const closePopup = document.querySelector('.close-popup');
  const popupContent = document.querySelector('.video-popup-content');

  // Abrir modal
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      let videoUrl = this.getAttribute('data-video-url');

      if(!videoUrl) {
        const videoSourceTag = this.querySelector('source');
        videoUrl = videoSourceTag.src;
      }

      popup.querySelector('source').setAttribute('src', videoUrl);
      popupVideo.load();
      popup.classList.add('visible');
      popup.classList.remove('hidden');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    });
  });

  // Función para cerrar modal
  function closeModal() {
    popup.classList.remove('visible');
    popup.classList.add('hidden');
    document.documentElement.style.overflow = 'initial';
    document.body.style.overflow = 'initial';
    popupVideo.pause();
  }

  // Botón cerrar
  closePopup.addEventListener('click', closeModal);

  // Click en overlay (fuera del contenido)
  popup.addEventListener('click', function (event) {
    if (event.target === popup) {
      closeModal();
    }
  });

  // Click en el contenedor del video (dentro del modal)
  popupContent.addEventListener('click', function () {
    closeModal();
  });
});
